import { render, staticRenderFns } from "./TerminalAnswer.vue?vue&type=template&id=0ed5aac0&scoped=true"
import script from "./TerminalAnswer.vue?vue&type=script&lang=js"
export * from "./TerminalAnswer.vue?vue&type=script&lang=js"
import style0 from "./TerminalAnswer.vue?vue&type=style&index=0&id=0ed5aac0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5aac0",
  null
  
)

export default component.exports